import React, { useState, useContext, useEffect } from 'react'
import SidebarApp  from '../Sidebar/Sidebar';
import Footer from '../Footer/Footer'
import { Light,Dark } from '../styles/Themes';
import StickyBox from 'react-sticky-box';
import {Outlet,useNavigate} from 'react-router-dom';// desde la V6 es routes no switch
import { CasUserContext, useCasUserContext } from '../../services/casUserContext';
import NavMenu from '../Navbar/Navbar';
import { ModalOrcId } from '../Modal/ModalOrcId';
import { ModalScholar } from '../Modal/ModalScholar';
import { Container, Grid, IconButton, LinearProgress, Stack } from '@mui/material';
import logoespol from '../../recursos_iconos/Portal_Investigacion_r.svg';
import { FaUserTie } from 'react-icons/fa';

interface Props{
isSecure?:false
}

export const ThemeContext=React.createContext(null);

const styles = {
  contentDiv: {
      display: "flex",
  },
  contentMargin: {
      marginLeft: "0px",
      width: "100%",
  },
};

export default function Layout (props:Props) {
  
  const[theme,setTheme] = useState("light")
  const themeStyle = theme === "light"? Light : Dark ;
  const navigate = useNavigate();
  const [b,setB] = useState<boolean>(true)  
  const currentPath = window.location.pathname;
  //const cas = useCas(b);
  //const casUserContext = useContext(CasUserContext);
  const casUserContext = useCasUserContext();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalOpenScholar, setModalOpenScholar] = useState<boolean>(false);
  const [menuVisible, setMenuVisible] = useState(true);

  const goToNavigation = (site:string) =>{
    navigate(site)
  }

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const abrirModal = (estado: boolean) => {
    setModalOpen(estado);
  };

  const cerrarModal = (estado: boolean) => {
    setModalOpen(estado);
  };

  const abrirModalScholar = (estado: boolean) => {
    setModalOpenScholar(estado);
  };

  const cerrarModalScholar = (estado: boolean) => {
    setModalOpenScholar(estado);
  };

  useEffect(() => {
    //console.log(casUserContext.user)
    //console.log(casUserContext.userData)
    //console.log(casUserContext.token)
    if(casUserContext.user){
      navigate(currentPath);
    }
  },[casUserContext.user]);

  if (casUserContext.checking) {
    return (
      <div>
        <div className='centrado' style={{ paddingTop:'25px', paddingBottom:'25px', borderBottom: '2px solid #243165', display: 'flex', justifyContent: 'space-between'}} >
                <img className='imgBox' width='350px' height='auto' src={logoespol} alt="" style={{marginLeft:'10%'}} onClick={() => {goToNavigation('/inicio/portalinvestigacion')}} />
                <IconButton color="default" style={{ color: '#243165',padding: '25px' }} onClick={() => goToNavigation('/')}>
                    <FaUserTie />
                </IconButton>
        </div>
        <Container maxWidth="lg" style={{paddingTop: '50px', paddingBottom:'50px'}}>
            <div className='wrapper'>
              <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                  <LinearProgress color="secondary" />
              </Stack>
            </div>
        </Container> 
    </div> 
    ); // Mostrar un indicador de carga mientras se obtienen los datos
  }

    return (          
      <div className='wrapper' >
        <div style={{ display: "flex", alignItems: "flex-start" }}>
                <StickyBox className='app-sidebar' offsetTop={20} offsetBottom={20} >
                  <SidebarApp idInv={casUserContext.userData.idinv} roles={casUserContext.userData.roles} />
                </StickyBox>
                <div className='main-panel' style={styles.contentMargin}>
                      <div style={{ paddingLeft: menuVisible ?'1vw' : '0', paddingRight:'1vw', paddingTop:'1vh',paddingBottom:'1vh', minHeight:'90vh' }}>
                      <StickyBox className='app-navbar' offsetBottom={20} >
                        <div>
                        {/* <div onClick={toggleMenu}> */}
                        <NavMenu 
                          nombreApp='' 
                          apellidos={casUserContext.userData.apellidos} 
                          nombres={casUserContext.userData.nombres}
                          foto={casUserContext.userData.foto}
                          abrirModal={abrirModal}
                          abrirScholar={abrirModalScholar}
                        />
                        </div>
                      </StickyBox>
                         {/*children*/}
                        <Container maxWidth="lg">
                          <Outlet/>
                        </Container>                       
                      </div>
                </div>
        </div>
      <div>
                <Footer />
            </div> 
            {true ? <></> : <ModalOrcId isOpen={modalOpen} cerrarModal={cerrarModal} /> }
            {true ? <></> : <ModalScholar isOpen={modalOpenScholar} cerrarModal={cerrarModalScholar} />   }   
      </div>
      
    );
}


